import React from "react";
import "../App.css";

function TigoPesa() {
  return (
    <div className="App">
      <div style={{ marginBottom: 10 }}>
        <p>Processing Tigo Payments</p>
      </div>

      <p>Waiting</p>
    </div>
  );
}

export default TigoPesa;
